<template>
  <div>
    <el-dialog
      top="20vh"
      width="450px"
      center
      :title="`${reportObj.bankName ? reportObj.bankName : ''} 上报`"
      :visible="dialogVisible"
      @close="HandleCancel"
      :close-on-click-modal="false"
    >
      <el-form
        v-loading="formLoading"
        :rules="rules"
        :model="editData"
        :ref="form"
        label-width="90px"
      >
        <el-form-item label="银行卡卡号">
          {{ reportObj.bankCardNumber }}
        </el-form-item>
        <el-form-item prop="eventType" label="上报原因">
          <el-select
            @change="HandleSwitch()"
            style="width: 290px"
            v-model="editData.eventType"
          >
            <el-option
              v-for="option in typeOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="editData.eventType === 0" label="下线原因">
          <el-select style="width: 290px" v-model="editData.remark">
            <el-option
              v-for="item in logOutReasonOption"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-else-if="editData.eventType === 5" label="禁用原因">
          <el-select style="width: 290px" v-model="editData.remark">
            <el-option
              v-for="item in adminDisableReasonOption"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-if="editData.eventType === 4" label="渠道">
          <el-select style="width: 290px" v-model="editData.faceScanRtspPk">
            <el-option
              v-for="item in faceScanRtspOptions"
              :key="item.label"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item v-else-if="editData.eventType === 2" label="余额">
          <el-input style="width: 290px" v-model="editData.remark" />
        </el-form-item>

        <div v-else-if="editData.eventType === 3">
          <el-form-item label="目标号码">
            <el-input style="width: 290px" v-model="editData.phoneNumber" />
          </el-form-item>
          <el-form-item label="描述">
            <el-input
              style="width: 290px"
              type="textarea"
              :autosize="{ minRows: 3, maxRows: 5 }"
              v-model="editData.remark"
            />
          </el-form-item>
        </div>

        <el-form-item
          v-else-if="
            editData.eventType && [4, 5].indexOf(editData.eventType) === -1
          "
          label="描述"
        >
          <el-input
            style="width: 290px"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 5 }"
            v-model="editData.remark"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="HandleCancel"> 取消 </el-button>
        <el-button :loading="loading" round type="success" @click="HandleVaild">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import { errorFeedback } from "@/api/account";
import { getLogOutReason, getAdminDisableReason } from "@/api/setting";
import { getFaceScanRtspMenu } from "@/api/faceScan";

export default {
  props: {
    reportObj: {
      type: Object,
    },
  },
  mixins: [mainCommon],
  data() {
    return {
      form: "form",
      formLoading: false,
      editData: {
        eventType: null,
        remark: null,
        phoneNumber: null,
      },
      faceScanRtspOptions: [],
      typeOptions: [
        // { label: "[需要扫脸]", value: 4 },
        // { label: "[下线帐号] 需要系统下线", value: 0 },
        // { label: "[帐号今日已满] 需要系统本日不再派单", value: 1 },
        { label: "[转发短信] 操作员上报发送短信消息", value: 3 },
        { label: "[上报余额] 更新账号最新余额", value: 2 },
        // { label: "[禁用银行卡] 系统级别禁用银行卡", value: 5 },
        // { label: "[其他问题反馈] 通知管理员", value: 99 },
      ],
      loading: false,
      dialogVisible: false,
      rules: {
        eventType: [{ required: true, message: "必填项目不可为空" }],
      },
      logOutReasonOption: [],
      adminDisableReasonOption: [],
    };
  },
  watch: {
    reportObj(row) {
      if (row) {
        this.dialogVisible = true;
        if (this.logOutReasonOption.length === 0) {
          // 如果空的再请求一次
          this.getLogOutReason();
        }
        if (this.adminDisableReasonOption.length === 0) {
          // 如果空的再请求一次
          this.getAdminDisableReason();
        }
        if (typeof this.reportObj.eventType === "number") {
          this.editData.eventType = this.reportObj.eventType;
        }
        if (this.reportObj.remark) {
          this.editData.remark = this.reportObj.remark;
        }
      }
    },
  },
  methods: {
    // 取得需要扫脸渠道选项
    getFaceScanRtspMenu() {
      getFaceScanRtspMenu().then((res) => {
        this.faceScanRtspOptions = res.data.map((res) => {
          return { label: res.direction, value: res.faceScanRtspPk };
        });
      });
    },
    // 取得下线帐号原因列表
    getLogOutReason() {
      this.formLoading = true;
      getLogOutReason()
        .then((res) => {
          this.logOutReasonOption = res.data;
        })
        .catch(() => {
          // 接口出错，移除对应的第一个下拉
          this.typeOptions.shift();
        })
        .finally(() => {
          this.formLoading = false;
        });
    },
    // 系统级别禁用银行卡
    getAdminDisableReason() {
      this.formLoading = true;
      getAdminDisableReason()
        .then((res) => {
          this.adminDisableReasonOption = res.data;
        })
        .finally(() => {
          this.formLoading = false;
        });
    },
    HandleSwitch() {
      this.editData.remark = null;
      this.editData.phoneNumber = null;

      // 如果为需要扫脸，才会请求渠道列表
      if (
        this.editData.eventType === 4 &&
        this.faceScanRtspOptions.length === 0
      ) {
        this.getFaceScanRtspMenu();
      }
    },
    HandleVaild() {
      this.$refs[this.form].validate((valid) => {
        if (valid) this.HandleSubmit();
      });
    },
    HandleSubmit() {
      // 下线帐号、禁用银行卡
      if (
        [0, 5].indexOf(this.editData.eventType) !== -1 &&
        !this.editData.remark
      ) {
        this.$notify.error("必填项目不可为空");
        return;
      }
      // 上报余额
      let pattern = new RegExp("^([1-9][0-9]*)+(.[0-9]{1,2})?$");
      if (
        this.editData.eventType === 2 &&
        this.editData.remark !== "0" &&
        !pattern.test(this.editData.remark)
      ) {
        this.$notify.error("输入非正数或必填项目为空");
        return;
      }

      // 目标号码
      let patternPhone = new RegExp("^\\+?\\d*$");
      if (
        this.editData.eventType === 3 &&
        (!this.editData.remark ||
          !this.editData.phoneNumber ||
          !patternPhone.test(this.editData.phoneNumber))
      ) {
        this.$notify.error("格式有误，请再确认");
        return;
      }

      // 需要扫脸
      if (this.editData.eventType === 4 && !this.editData.faceScanRtspPk) {
        this.$notify.error("请选择渠道地址");
        return;
      }

      this.loading = true;
      this.editData.accId = this.reportObj.id;
      errorFeedback(this.ObjectClean(this.editData))
        .then((res) => {
          // 提现回单操作银行卡信息上报余额，会需要时间更新，因此跳提示
          if (
            this.editData.eventType === 2 &&
            this.userInfo.userType === "customer"
          ) {
            this.$notify.success("操作成功，余额同步后几秒刷新才会是最新的");
          } else {
            this.$notify.success(res.message);
          }
          this.dialogVisible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    HandleCancel() {
      this.editData.faceScanRtspPk = null;
      this.$refs[this.form].resetFields();
      this.dialogVisible = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/components/dialog/Report.vue